import styled from "styled-components";

export const StyledBody = styled.div`
  background-color: ${({ theme }) => theme.pureWhite};
  width: 100%;
  /* min-width: 90vw; */
  /* margin-top: 5rem; */
`;
